// src/components/AllProjects.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AllProjects.module.css';

import surveyImg from '../assets/1.png';
import hotelImg from '../assets/adila.png';
import deliveryThumb from '../assets/DeliverySC/customer/D1.png';
import ecomThumb from '../assets/E1.png';
import uiThumb from '../assets/UI.png';

const projects = [
  {
    title: 'Online Survey System',
    description: 'A Java-based web app built using JSP, Servlet, and MySQL.',
    link: '/projects/survey',
    image: surveyImg,
  },
  {
    title: 'Hotel Management System',
    description: 'Full-stack project using HTML, CSS, JS, PHP, and MySQL.',
    link: '/projects/hotel',
    image: hotelImg,
  },
  {
    title: 'Delivery Management System',
    description: 'A full delivery platform built with JavaScript, React (Vite), and a Node + Express backend.',
    link: '/projects/delivery',
    image: deliveryThumb,
  },
  {
    title: 'TrendyMerches (E‑commerce)',
    description:
      'E‑commerce platform (intern at Fanaye Technology): customers sign in to browse and buy products; influencers create accounts to promote items and earn commissions. Built with TypeScript, Node.js and PostgreSQL. Live site available.',
    external: 'https://www.trendymerches.com/',
    image: ecomThumb,
  },
  {
    title: 'E-commerce UI Design',
    description:
      'A polished Figma UI concept for an e-commerce website, created to explore a modern, intuitive shopping experience with clean layout structure and user-focused visuals.',
    external: uiThumb,
    buttonLabel: 'View Site',
    image: uiThumb,
  },
];

export default function Projects() {
  return (
    <section className={styles.projects} id="projects">
      <h2 className={styles.heading}>Projects</h2>

      {/* First Row: Survey + Hotel side by side */}
      <div className={styles.sideBySide}>
        {[projects[0], projects[1]].map((project, index) => (
          <div key={index} className={`${styles.projectCard} ${styles.sideCard}`}>
            <img
              src={project.image}
              alt={project.title}
              className={styles.projectImage}
            />
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <Link to={project.link} className={styles.btn}>
              View Details
            </Link>
          </div>
        ))}
      </div>

      {/* Second Row: remaining projects (starting at index 2) */}
      <div className={styles.projectList}>
        {projects.slice(2).map((project, index) => (
          <div key={index} className={styles.projectCard}>
            {project.external ? (
              <div className={styles.externalCard}>
                <img src={project.image} alt={project.title} className={styles.projectImage} />
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <a href={project.external} target="_blank" rel="noreferrer" className={styles.btn}>
                  {project.buttonLabel || 'Visit Site'}
                </a>
              </div>
            ) : (
              <>
                <img src={project.image} alt={project.title} className={styles.projectImage} />
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                {project.link && (
                  <Link to={project.link} className={styles.btn}>
                    View Details
                  </Link>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
